import * as Yup from "yup";
import {
  ageValidation,
  emailField,
  minLength,
  maxLength,
  requiredField,
} from "../../../../shared/helpers/getMessageValidation";

export const addresSchema = Yup.object({
  street: Yup.string().required(requiredField()),
  number: Yup.string().required(requiredField()),
  zipCode: Yup.string().required(requiredField()),
  country: Yup.object()
    .shape({
      name: Yup.string().required(requiredField()),
    })
    .typeError(requiredField()),
  locality: Yup.object()
    .shape({
      name: Yup.string().required(requiredField()),
    })
    .typeError(requiredField()),
  province: Yup.object()
    .shape({
      name: Yup.string().required(requiredField()),
    })
    .typeError(requiredField()),
});

export const contactSchema = Yup.object({
  partMobileNumber: Yup.string()
    .required(requiredField())
    .matches(/^[0-9]+$/, "Este campo solo admite números")
    .test('sum-length', 'La sumatoria de los campos Código de área y Número de teléfono debe tener 12 caracteres', function (value) {
      return (value + this.parent.areaCode).length === 12;
    })
    .test('first-two-are-15', 'Los dos primeros caracteres deben ser 15', value => value ? value.slice(0, 2) === '15' : false),
  areaCode: Yup.string()
    .required(requiredField())
    .matches(/^[0-9]+$/, "Este campo solo admite números")
    .test('sum-length', 'La sumatoria de los campos Código de área y Número de teléfono debe tener 12 caracteres', function (value) {
      return (value + this.parent.partMobileNumber).length === 12;
    })
    .test('first-not-zero', 'El primer caracter no puede ser 0', value => value ? value[0] !== '0' : false),
  partAlternativePhoneNumber: Yup.string()
    .required(requiredField())
    .matches(/^[0-9]+$/, "Este campo solo admite números")
    .when("phoneType", {
      is: "Movil",
      then: Yup.string()
        .test('first-two-are-15', 'Los dos primeros caracteres deben ser 15', value => value ? value.slice(0, 2) === '15' : false)
        .test('sum-length', 'La sumatoria de los campos Código de área y Número de teléfono debe tener 12 caracteres', function (value) {
          return (value + this.parent.alternativeAreaCode).length === 12;
        }),
      otherwise: Yup.string()
        .test('sum-length', 'La sumatoria de los campos Código de área y Número de teléfono debe tener 11 caracteres', function (value) {
          return (value + this.parent.alternativeAreaCode).length === 11;
        })
      }),
      alternativeAreaCode: Yup.string()
      .required(requiredField())
      .matches(/^[0-9]+$/, "Este campo solo admite números")
      .when("phoneType", {
        is: "Movil",
        then: Yup.string()
        .test('first-not-zero', 'El primer caracter no puede ser 0', value => value ? value[0] !== '0' : false)
        .test('sum-length', 'La sumatoria de los campos Código de área y Número de teléfono debe tener 12 caracteres', function (value) {
          return (value + this.parent.partAlternativePhoneNumber).length === 12;
        }),
        otherwise: Yup.string()
        .test('sum-length', 'La sumatoria de los campos Código de área y Número de teléfono debe tener 11 caracteres', function (value) {
          return (value + this.parent.partAlternativePhoneNumber).length === 11;
        })
        .matches(/^0.*/, 'El primer caracter debe ser 0')
    }),
  contactAlternativeName: Yup.string().required(requiredField()),
});

export const personSchema = Yup.object({
  firstName: Yup.string().required(requiredField()),
  lastName: Yup.string().required(requiredField()),
  mail: Yup.string().email(emailField()).required(requiredField()),
  document: Yup.string().when("documentType", {
    is: "ID",
    then: Yup.string()
      .required(requiredField())
      .trim()
      .min(7, minLength(7))
      .max(9, maxLength(9))
      .matches(
        /^[0-9,M,F,f,m]+$/,
        "Este campo solo admite números y la letra M y F"
      ),
    otherwise: Yup.string()
      .required(requiredField())
      .trim()
      .min(8, minLength(8)),
  }),

  cuil: Yup.string()
    .required(requiredField())
    .trim()
    .min(11, minLength(11))
    .matches(/^[0-9]+$/, "Este campo solo admite números"),
  birthDate: Yup.date()
    .required(requiredField())
    .max(new Date(Date.now() - 567648000000), ageValidation()),
  country: Yup.object()
    .shape({
      name: Yup.string().required(requiredField()),
    })
    .typeError(requiredField()),
});

export const getSchemaValidationFirstStep = () => {
  const firstStepValidation = Yup.object().shape({
    person: personSchema,
    address: addresSchema,
    contactInformation: contactSchema,
  });
  return firstStepValidation;
};
